import type { PropsWithChildren } from 'react';
import { GlobalStyles } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { config } from 'shared/config';
import theme from 'shared/ui/theme';
import { ActivePageProvider } from 'features/report-workspace/public/page/ActivePageContext';
import { UIPreferencesProvider } from 'features/preferences/public/UIPreferencesContext';
import ConnectionRecovery from 'features/connections/public/ConnectionRecovery';
import SessionBootstrap from 'features/identity/public/SessionBootstrap';
import { AppPanelProvider } from 'features/navigation/public/appPanelState';

const globalStyles = {
    html: { margin: 0, padding: 0, height: '100%', overflow: 'hidden' },
    body: { margin: 0, padding: 0, height: '100%', overflow: 'hidden' },
    '#root': { height: '100%' },
};

const ProductProviders = ({ children }: PropsWithChildren) => (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles styles={globalStyles} />
        <SessionBootstrap><UIPreferencesProvider>
            <ActivePageProvider><AppPanelProvider>{children}<ConnectionRecovery /></AppPanelProvider></ActivePageProvider>
        </UIPreferencesProvider></SessionBootstrap>
    </ThemeProvider>
);

const AppProviders = ({ children }: PropsWithChildren) => {
    const product = <ProductProviders>{children}</ProductProviders>;
    // A public link's address is its credential: Google's sign-in script is not loaded there.
    if (!config.GOOGLE_CLIENT_ID || window.location.pathname.startsWith('/p/')) {
        return product;
    }

    return (
        <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID}>
            {product}
        </GoogleOAuthProvider>
    );
};

export default AppProviders;
